module.exports = __webpack_public_path__ + "img/暂无队员@2x.df8028d7.png";